module.exports = __webpack_public_path__ + "static/media/7-5.5222cc9f.mp3";